import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, output, signal } from "@angular/core";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { S25Util } from "../../../util/s25-util";
import { TrailApi } from "./trail.api";
import { TrailLabels } from "./trail.labels";

@TypeManagerDecorator("s25-ng-trail-refresh-button")
@Component({
    selector: "s25-ng-trail-refresh-button",
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule],
    template: `
        <button type="button" class="trail-refresh-btn" [disabled]="refreshing()" (click)="refresh()">
            @if (refreshing()) {
                <span class="trail-refresh-btn__spinner"></span>
                Updating…
            } @else {
                {{ labels.UPDATE_PROGRESS }}
            }
        </button>
    `,
    styles: [
        `
            :host {
                display: inline-block;
            }
            .trail-refresh-btn {
                display: inline-flex;
                align-items: center;
                gap: 0.4rem;
                padding: 0.45rem 1rem;
                border: 1px solid var(--cn-navy, #1e3a5f);
                border-radius: 4px;
                background: transparent;
                color: var(--cn-navy, #1e3a5f);
                font-size: 0.9rem;
                cursor: pointer;
                font-weight: 500;
                transition:
                    background 0.15s ease,
                    color 0.15s ease;
            }
            .trail-refresh-btn:hover:not(:disabled) {
                background: var(--cn-navy, #1e3a5f);
                color: #fff;
            }
            .trail-refresh-btn:disabled {
                opacity: 0.6;
                cursor: not-allowed;
            }
            .trail-refresh-btn__spinner {
                display: inline-block;
                width: 14px;
                height: 14px;
                border: 2px solid currentColor;
                border-top-color: transparent;
                border-radius: 50%;
                animation: trail-spin 0.6s linear infinite;
            }
            @keyframes trail-spin {
                to {
                    transform: rotate(360deg);
                }
            }
        `,
    ],
})
export class TrailRefreshButtonComponent {
    readonly labels = TrailLabels;
    readonly refreshing = signal(false);

    readonly refreshed = output<void>();

    async refresh(): Promise<void> {
        if (this.refreshing()) return;

        this.refreshing.set(true);
        try {
            await TrailApi.refresh();
            this.refreshed.emit();
        } catch (caughtError) {
            S25Util.showError(caughtError, "Unable to refresh progress");
        } finally {
            this.refreshing.set(false);
        }
    }
}
